<template>
<div>
  <!-- <div :class="['container',  _isMobile()?'mobile':'']" :style="{ 'background-image': 'url(' + bgUrl + ')' }">
    <Header />
    <div class="banner">
      <Banner/>
    </div>
    <div class="home"> -->
    <a-card class="news" :bordered="false" v-if="articleList.length>0">
      <a-row>
        <a-col :xs="8" :sm="8" :md="7" :lg="4" :xl="4"><h3>最新信息</h3></a-col>
        <a-col :xs="8" :sm="8" :md="10" :lg="16" :xl="16">
          <router-link :to="{path:'cms/detail', query: {id: articleList[0].id, category:1}}">{{articleList[0].cmsTitile}}</router-link>
        </a-col>
        <a-col :xs="8" :sm="8" :md="7" :lg="4" :xl="4" class="see-more">
          <router-link :to="{path:'news', query:{category:1}}">
            <h4>查看更多>></h4>
          </router-link>
          </a-col>
      </a-row>
    </a-card>

    <!-- 课程教学 -->
    <a-divider />
    <a-row type="flex" justify="space-between" class="column-title">
      <a-col :span="12" class="common-title"><h3>课程资源</h3></a-col>
      <a-col :span="12" class="see-more">
        <router-link to="/course">
          <h4>查看更多>></h4>
        </router-link>
        </a-col>
    </a-row>
    <a-card class="column-card" :bordered="false">
      <a-row type="flex" justify="space-between" :gutter="24">
        <!-- <a-col flex="270px" :xs="0" :sm="0" :md="0" :lg="0" :xl="6">
          <img style="height:430px;margin-bottom:25px;" src="../assets/course-ad.png" alt="">
        </a-col> -->
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <a-skeleton v-if="courseLoading"/>
          <a-list
            :grid="{ gutter: _isMobile()?12:24, lg: 3, md: 3, sm: 2, xs: 2 }"
            :dataSource="courseDataSource"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-card class="item-card" :bordered="false" @click="toCourseDetail(item.id)">
                <img class="cover" :src="item.courseCover_url" alt="">
                <h3 class="title">{{ item.courseName }}</h3>
              </a-card>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-card>

    <!-- 认证产品 -->
    <a-divider />
    <a-row type="flex" justify="space-between" class="column-title">
      <a-col :span="12" class="common-title"><h3>器材教材</h3></a-col>
      <a-col :span="12" class="see-more">
        <router-link to="/production"><h4>查看更多>></h4></router-link>
      </a-col>
    </a-row>
    <a-card class="column-card" :bordered="false">
      <a-skeleton v-if="productLoading"/>
      <a-list
        :grid="{ gutter: _isMobile()?12:24, lg: 4, md: 4, sm: 2, xs: 2 }"
        :dataSource="productDataSource"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" class="item-card" @click="toProductDetail(item.id)">
            <img class="cover" :src="item.productCover_url" alt="">
            <h3 class="title">{{ item.productName }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>

    <!-- 考试题库 -->
    <a-divider />
    <a-row type="flex" justify="space-between" class="column-title paper-wrap">
      <a-col :span="12" class="common-title"><h3>测评题库</h3></a-col>
      <a-col :span="12" class="see-more">
        <router-link to="/paper">
          <h4>查看更多>></h4>
        </router-link>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between" :gutter="25">
      <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
        <a-card class="column-card" :bordered="false" style="min-height: 222px;">
          <a-list :dataSource="paperDataSource1">
            <a-list-item slot="renderItem" slot-scope="item">
                <h3 class="title"><a-tag>{{ item.paperType_dictText }}</a-tag>{{ item.paperName }}</h3>
                <a-button class="to-exam-btn" v-if="item.userPaperStatus>0 && (item.submitTimesLimit==-1 || (item.submitTimesLimit>=item.mySubmitTimes))" size="small" @click="toPaper(item, true)"
                >再次考试</a-button>
                <a-divider type="vertical"/>
                <a-button class="to-exam-btn" size="small" @click="toPaper(item, false)"
                >{{item.userPaperStatus==0?'继续考试':(item.userPaperStatus==1||item.userPaperStatus>1?'已交卷':'去考试')}}<a-icon type="right"
                /></a-button>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>
      <a-col :xs="0" :sm="0" :md="12" :lg="12" :xl="12">
        <a-card class="column-card" :bordered="false" style="min-height: 222px;">
          <a-list :dataSource="paperDataSource2">
            <a-list-item slot="renderItem" slot-scope="item">
                <h3 class="title"><a-tag>{{ item.paperType_dictText }}</a-tag>{{ item.paperName }}</h3>
                <a-button class="to-exam-btn" v-if="item.userPaperStatus>0 && (item.submitTimesLimit==-1 || (item.submitTimesLimit>=item.mySubmitTimes))" size="small" @click="toPaper(item, true)"
                >再次考试</a-button>
                <a-divider type="vertical"/>
                <a-button class="to-exam-btn" size="small" @click="toPaper(item, false)"
                >{{item.userPaperStatus==0?'继续考试':(item.userPaperStatus==1||item.userPaperStatus>1?'已交卷':'去考试')}}<a-icon type="right"
                /></a-button>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>
    </a-row>

    <!-- 师训赛事 -->
    <a-divider />
    <a-row type="flex" justify="space-between"  class="column-title">
      <a-col :span="12" class="common-title"><h3>教师活动</h3></a-col>
      <a-col :span="12" class="see-more">
        <router-link to="/contest">
        <h4>查看更多>></h4>
        </router-link>
        </a-col>
    </a-row>
    <a-card class="column-card" :bordered="false">
      <a-skeleton v-if="contestLoading"/>
      <a-list
        :grid="{ gutter: _isMobile()?12:24, lg: 4, md: 4, sm: 2, xs: 2 }"
        :dataSource="contestDataSource"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" class="item-card" @click="toContestDetail(item.id)">
              <img class="cover" :src="item.contestCover_url" alt="">
              <h3 class="title">{{ item.contestName }}</h3>
            </a-card>
        </a-list-item>
      </a-list>
    </a-card>
    <!-- <a-divider /> -->
    <!-- </div> -->
    <a-back-top />
    <!-- <Footer />
  </div> -->
</div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG ,ACCESS_TOKEN } from "@/store/mutation-types";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import {getAction} from "@/api/manage"
import {mixinDevice} from '@/utils/mixin.js'
import {getInfo} from '@/api/login'

export default {
  name: "Home",
  mixins: [mixinDevice],
  components: {
    Header,
    Footer,
    Banner
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
      articleList:[],
      courseDataSource: [
      ],
      courseLoading: false,
      productDataSource: [
      ],
      productLoading: false,
      contestDataSource: [
      ],
      contestLoading: false,
      paperDataSource1: [
      ],
      paperLoading1: false,
      paperDataSource2: [
      ],
      paperLoading2: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 8,
      },
      tenantConfig:{},
      token:''
    };
  },
  created() {
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    this.getArticleList()
    this.getPaperList()
    this.getCourseList()
    this.getProductList()
    this.getContestList()
    // this.getUserInfo()
  },
  mounted(){
    window.document.title = this.tenantConfig.brandName + " " + "首页"
  },
  methods: {
    getUserInfo(){
      getInfo().then(res=>{
        console.log(res);
      })
    },
    getArticleList() {
      // getArticleList(1, 1, 1).then((res) => {
      //   if (res.success) {
      //     this.articleList = res.result.records;
      //   }
      // });
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        pageSize: 1,
      }).then((res) => {
        if (res.success) {
          this.articleList = res.result.records;
        }
      });
    },
    getPaperList(){
      this.paperDataSource1 = []
      this.paperDataSource2 = []
      // if(this.token){
      //   getAction('/teaching/teachingPaper/minePaperList', {
      //     pageSize: 8,
      //   }).then((res) => {
      //     if(res.success){
      //       this.paperDataSource1 = res.result.slice(0,4)
      //       if(res.result.total > 4){
      //         this.paperDataSource2 = res.result.slice(4,8)
      //       }
      //     }
      //   })
      // }else{
        getAction("/teaching/teachingPaper/list", {
          paperStatus:2,
          pageSize:8
        }).then(res=>{
        if(res.success){
          this.paperDataSource1 = res.result.records.slice(0,4)
          if(res.result.total > 4){
            this.paperDataSource2 = res.result.records.slice(4,8)
          }
        }
        })
      // }
    },
    toPaper(info, redo) {
      if(redo){
          this.redoExam(info)
        }else{
          this.toExam(info)
        }
    },
    redoExam(info){
      let paperId
      if("paperId" in info){
        paperId = info.paperId
      }else{
        paperId = info.id
      }
      this.$router.push({
       path: '/examine',
        query: {
          id: paperId,
          departId: info.departId,
        },
      })
    },
    toExam(info){
      let paperId
      if("paperId" in info){
        paperId = info.paperId
      }else{
        paperId = info.id
      }
      this.$router.push({
        path: '/examine',
        query: {
          id: paperId,
          departId: info.departId,
          userPaperId: info.userPaperId
        },
      })
    },
    getCourseList(){
      this.courseLoading = true
      this.courseDataSource = []
      //  if(this.token){
      //    getAction('/teaching/teachingCourse/studentCourseNew', {pageSize:8}).then(res => {
      //     if (res.success) {
      //       this.courseDataSource = res.result
      //     }
      //     if (res.code === 510) {
      //       this.$message.warning(res.message)
      //     }
      //     this.courseLoading = false
      //   })
      //  }else{
         getAction("/teaching/teachingCourse/showCourse", {
          pageSize:8,
          isShow:1
          }).then(res=>{
          console.log(res);
          if(res.success){
            this.courseDataSource = res.result.records
          }
          this.courseLoading = false
        })
      //  }
      
    },
    toCourseDetail(id){
      this.$router.push({
        path: '/course/detail',
        query: {
          id: id,
        },
      })
    },
    getProductList(){
      this.productLoading = true
      this.dataSource = []
      getAction("/teaching/teachingProduct/list", {pageSize:4,productStatus:2}).then(res=>{
        console.log(res);
        if(res.success){
          this.productDataSource = res.result.records
        }
        this.productLoading = false
      })
    },
    toProductDetail(id){
      this.$router.push({
        path: '/production/detail',
        query: {
          id: id,
        },
      })
    },
    getContestList() {
      this.contestLoading = true;
      this.contestDataSource = [];
      getAction("/teaching/teachingContest/contestList", {
        pageSize: 4,
        contestStatus:2
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.contestDataSource = res.result.records;
        }
        this.contestLoading = false;
      });
    },
    toContestDetail(id) {
      this.$router.push({
        path: "/contest/detail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f2f6f8;

  /deep/.column-card{
    .ant-list-item{
      margin-bottom: 0;
    }
    .ant-card-body{
      padding: 25px 25px 0;
    }
  }
  
  
  .home {
    max-width: 1200px;
    margin: 30px auto;
    .news{
      height: 50px;
      /deep/.ant-card-body{
        padding: 12px 24px!important;
      }
    }
    .common-title{
      h3{
          font-size: 24px;
          font-weight: normal;
          line-height: 24px;
      }
    }
    .see-more{
      h4{
        color: #999;
        text-align: right
      }
      h4:hover{
        color: #1890FF;
      }
    }
    .item-card{
      cursor: pointer;
      /deep/.ant-card-body{
        padding:0;
        margin-top: 0;
        margin-bottom: 25px;
      }
      .cover{
        width: 100%;
        height: 170px;
        margin-bottom: 10px;
      }
    }
    .title{
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 0;
      overflow: hidden;
    }
  }
}


//paper item
.column-card{
  /deep/.ant-list-item:first-child{
    padding-top: 0!important;
  }
}

.title:hover{
  color: #1890FF;
}


.mobile{
  .column-title{
    padding: 0 25px;
  }
  .ant-card-body{

  }
  .item-card{
    /deep/.ant-card-body{
        margin-bottom: 12px!important;
      }
    .cover{
      height: 100px!important;
    }
  }
}
</style>